import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { releasePayment } from "store/actions/ordersAction";

const PaymentReleaseConfirmation = ({
  modal,
  toggle,
  singleOrder,
  status,
  page,
}) => {
  const dispatch = useDispatch();
  const { allOrdersLoader } = useSelector((state) => state.orders);
  const handleReleasePayment = () => {
    dispatch(
      releasePayment(singleOrder?._id, status, page, () => {
        toggle();
      })
    );
  };
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>
          <h4>Confirmation</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col className="m-auto">
              <Label className="font-weight-bold mb-4">
                Are you sure! You want to release payment against this order?
              </Label>
              <div className="d-flex justify-content-end">
                <Button onClick={toggle}>Cancel</Button>
                <Button
                  disabled={allOrdersLoader}
                  onClick={handleReleasePayment}
                  className="bg-primary text-white"
                >
                  {allOrdersLoader ? "Loading" : "Confirm"}
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PaymentReleaseConfirmation;
